import { render, staticRenderFns } from "./WritingBox.vue?vue&type=template&id=bb9bcf6a"
import script from "./WritingBox.vue?vue&type=script&lang=js"
export * from "./WritingBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports